export const isErrorEvent = (error: unknown): error is ErrorEvent =>
  !!error && typeof error === "object" && "error" in error;
